<template>
  <div v-if="planner != null">

    <PageHeader v-bind:label="isUserThisPlanner ? 'Site Appearance' : planner.first_name + ' ' + planner.last_name + ' Site Appearance'"></PageHeader>

    <div class="my-8">

      <div class="">
        <ImageUpload
          label="Logo - This will appear on the left hand side of the banner"
          propertyKey="logo"
          v-bind:image="planner.logo"
          v-bind:uploadFile="uploadFile"
          v-bind:deleteFile="deleteFile"></ImageUpload>
      </div>

      <div class="label-line">
        <ImageUpload
          label="Profile image - This will appear on the right hand side of the banner"
          propertyKey="profile_image"
          v-bind:image="planner.profile_image"
          v-bind:uploadFile="uploadFile"
          v-bind:deleteFile="deleteFile"></ImageUpload>
      </div>

      <div class="label-line">
        <div class="label-standard">Banner text color</div>
      </div>

      <div class="radio-line flex items-center">
        <InputRadio
          name="inputBannerTextColor"
          id="inputBannerTextColorWhite"
          propertyKey="header_text"
          objectType="planner"
          value="0"
          v-bind:checked="planner.header_text == 0"
          v-bind:updateValue="updateValue" />

        <label class="text-base ml-2 mr-8" for="inputBannerTextColorWhite">White</label>
        
        <InputRadio
          name="inputBannerTextColor"
          id="inputBannerTextColorBlack"
          propertyKey="header_text"
          objectType="planner"
          value="1"
          v-bind:checked="planner.header_text == 1"
          v-bind:updateValue="updateValue" />

        <label class="text-base ml-2 mr-8" for="inputBannerTextColorBlack">Black</label>
      </div>

      <div class="label-line">
        <label class="label-standard">Banner background color</label>
        <a href="#"
          class="ml-4 no-underline text-blue-600 hover:underline"
          v-on:click.prevent="updateValue({key: 'header_background', value:'#ffffff'})">Reset</a>
      </div>

      <div class="mt-4">
        <sketch-picker v-model="headerBackgroundColor"></sketch-picker>
      </div>

      <div class="label-line" style="width:520px;">
        <InputText
          label="Youtube video link"
          propertyKey="video"
          objectType="planner"
          v-bind:value="planner.video"
          v-bind:updateValue="updateValue"
          placeholder="https://www.youtube.com/watch?v=dGIjhtZ1Cyw"></InputText>
      </div>

      <div class="form-line">
        <template v-if="planner.video != null && planner.video != ''">
          <iframe
            style="width:520px;height:300px;"
            :src="getYoutubeVideoId(planner.video)"
            frameborder="0"
            allowfullscreen></iframe>
        </template>

        <template v-else>
          <iframe
            style="width:520px;height:300px;"
            src="https://www.youtube.com/embed/dGIjhtZ1Cyw"
            frameborder="0"
            allowfullscreen></iframe>
        </template>
      </div>
    </div>
    <AutoSaveLoader v-bind:autoSaving="autoSaving"></AutoSaveLoader>
  </div>
</template>

<script>
  import axios            from "axios"
  import { EventBus }     from '@/shared/event-bus'
  import { Sketch }       from 'vue-color'
  import InputText        from '@/shared/components/form/InputText'
  import ImageUpload      from '@/shared/components/form/ImageUpload'
  import InputRadio       from '@/shared/components/form/InputRadio'
  import PageHeader       from '@/shared/components/headers/PageHeader'
  import AutoSaveLoader   from '@/shared/components/loaders/AutoSaveLoader'

  export default {

    components: {
      'sketch-picker': Sketch,
      ImageUpload,
      InputRadio,
      InputText,
      PageHeader,
      AutoSaveLoader
    },

    data () {
      return {
        loading   : false,
        autoSaving: false,
        planner    : null,
        videoUrl  : 'https://www.youtube.com/watch?v=dGIjhtZ1Cyw',
      }
    },

    created() {
      this.getCurrentPlanner()
    },

    computed : {
      headerBackgroundColor : {
        get() {
          if(this.planner.header_background != null) {
            return this.planner.header_background
          } else {
            return '#182F64'
          }
        },

        set(value) {
          this.updatePlanner(this.planner, "header_background", value.hex)
        }
      }
    },

    mounted() {
      EventBus.$on('set-autosave', trueOrFalse => {
        this.autoSaving = trueOrFalse
        this.loading = trueOrFalse
      });
    },

    destroyed() {
      EventBus.$off('set-autosave')
    },

    methods : {

      getCurrentPlanner() {       
        this.apiGet({
          plannerId : this.$route.params.plannerId
        }, 'planner/detail', (planner) => {
          this.planner = _.cloneDeep(planner)
        })        
      },

      uploadFile($event, fileType) {
        let file     = $event.target.files[0] || $event.dataTransfer.files[0]
        let formData = new FormData()
        formData.append('file', file)
        formData.append('fileType', fileType)
        formData.append('plannerId', this.planner.id)
        this.showLoader("Uploading...")

        axios.post(process.env.VUE_APP_API_URL + '/api/planner/upload', formData, {
          headers: {
            'Content-Type'  : 'multipart/form-data',
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
          this.hideLoader()
          this.getCurrentPlanner()
        }).catch(function(err) {
          this.hideLoader()
        });
      },

      updateValue(params) {
        this.updatePlanner(this.planner, params.key, params.value)
      },

      deleteFile(type) {
        this.$modal.show('confirm-modal', {
          // width : 600,
          title  : "Please confirm your action",
          message: "Are you sure you want to delete this?",
          buttons:[{
            label          : 'Yes',
            color          : 'red',
            loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
            action         : () => {
              this.apiDelete({
                plannerId: this.planner.id,
                type     : type
              }, 'planner/delete-upload', () => {
                this.$modal.hide('confirm-modal')
                this.getCurrentPlanner()
                EventBus.$emit('notification-event', {
                  'type'   : 'success',
                  'message': "File deleted successfully"
                });
              })
            }
          }, {
            label : 'No',
            color : 'gray',
            action: () => {
              this.$modal.hide('confirm-modal')
            }
          }]
        })
      },
    }
  }
</script>